/* agmf-builder-swap.js — while the shopper is building, the build is the picture.
 *
 * Dorian 2026-10-01: "The build replaces the card while they're building."
 *
 * The gear builder already swaps its column. When the shopper ticks something
 * in "Add to your setup" that can be drawn, agb-panels.js
 * (manageCanvasGalleryVisibility) shows the live composite #CustomProductCanvas
 * and hides the product gallery; when nothing drawable is left it does the
 * reverse. It does it with an inline `display` on the canvas.
 *
 * On a page carrying the media feed the gallery is gone: the product card
 * (.agmf-hero) stands in that place (agilite-media-flow.css keeps the theme
 * gallery hidden for good). So the builder's swap only ever turned its canvas
 * ON - and the shopper got the card AND the build, one under the other.
 *
 * This makes the card take the gallery's part in that swap, by watching the
 * builder's own switch rather than re-deciding when a build "counts": the
 * builder already refuses to show a canvas with nothing paintable on it
 * (an art-less accessory, a skipped base), and a second opinion here would be
 * a second answer to disagree with. Canvas shown -> html.agmf-building -> the
 * card's PICTURES are out of the layout, and the canvas, which sits below them
 * in the same column, moves up into their place. Canvas hidden -> they return.
 *
 * ONLY THE PICTURES, NEVER THE HEAD. The card is three parts - .agmf-hero-head
 * (name, rating, price), .agmf-hero-track (the pictures) and .agmf-hero-dots.
 * On a phone the head IS the page's title: the theme's own <h1> is hidden in
 * its favour. Hiding the whole card took the name and the price off the screen
 * for as long as the shopper was building (measured at 375px, 2026-10-01). So
 * the head stays, and the build reads under the product's own name.
 *
 * Its videos stop by themselves: a card with no box is never "on screen" to
 * the engine's visibility pass, which pauses anything that is not.
 *
 * Builder pages only - it stands down on any page without the builder's
 * canvas, and edits nothing either feature owns.
 * Kill: window.AGMF_BUILDER_SWAP_OFF = true.
 */
(function () {
  'use strict';
  if (window.__agmfBuilderSwap || window.AGMF_BUILDER_SWAP_OFF) return;
  window.__agmfBuilderSwap = true;

  var CLASS = 'agmf-building';
  var style = document.createElement('style');
  // !important because the hero's own rules show it with high specificity
  // (html.agmf-hero-live ...). The pictures and their dots only - the head
  // stays (see above); the feed, the buy column and the builder's sticky
  // canvas are untouched.
  style.textContent =
    'html.' + CLASS + ' .agmf-hero-track,' +
    'html.' + CLASS + ' .agmf-hero-dots{display:none !important}' +
    /* THE CARD FITS THE BUILDER'S COLUMN ON A PHONE. On a phone the card is
       full-bleed (agilite-media-flow.css: a calc(50% - 50vw) margin), which on
       the belt's page spans the screen. Here it sits inside #summary-panel,
       which clips to its own box (overflow:hidden, contain:layout paint, 20px
       in from the edge) - so the column cut the card's edges, the first letters
       of the name and the price included ("-Zero", " 344.00", measured at 375px,
       2026-10-01). The builder's column is its own layout and stays as it is;
       the card, ours, takes the column's width instead, in line with
       everything else on this page. #summary-panel exists only on builder
       pages, so the belt's card is untouched. */
    '@media (max-width:759.98px){#summary-panel>.agmf-hero{margin-left:0;margin-right:0;width:auto}}';
  (document.head || document.documentElement).appendChild(style);

  function building(canvas) {
    // the builder's switch is an inline display; computed style also covers a
    // stylesheet that hides the canvas before the builder has spoken
    return getComputedStyle(canvas).display !== 'none';
  }

  function apply(canvas) {
    var on = building(canvas);
    var root = document.documentElement;
    if (on === root.classList.contains(CLASS)) return;
    root.classList.toggle(CLASS, on);
    try {
      document.dispatchEvent(new CustomEvent('agmf:building', { detail: { building: on } }));
    } catch (e) { /* the swap works without the event */ }
    // the engine's visibility pass runs on scroll and on its own timer; a
    // scroll nudge lets a card that just came back start its video at once
    try { window.dispatchEvent(new Event('scroll')); } catch (e) {}
  }

  function start() {
    var canvas = document.getElementById('CustomProductCanvas');
    if (!canvas) return false;
    apply(canvas);
    new MutationObserver(function () { apply(canvas); })
      .observe(canvas, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    return true;
  }

  /* DESKTOP is no longer done here: pdp-desk-3col.js now recognises the
     builder's page and runs the Magnetix desktop itself - panes that scroll
     together, the header that slides away, the footer strip (2026-10-01). One
     correction to it lives here because only this file knows the page is a
     builder page: a VERTICAL clip never spans (Magnetix's own rule, "a
     VERTICAL clip ... keeps its single column"), yet Shorts drawn 9:16 arrived
     stamped data-agmf-span on K-Zero SF and filled both columns at 672x896. */
  if (document.getElementById('CustomProductCanvas')) {
    document.documentElement.classList.add('agmf-builder-page');
    style.textContent +=
      'html.agmf-builder-page.agdesk-on .agdesk-media .agmf-cycle>.agmf-card[data-agmf-span]' +
      ':has(.agmf-media--916){grid-column:auto}';
  }

  if (!start()) {
    // the builder section is server-rendered, so this is only a late-parse
    // safety net; a page with no builder simply never finds the canvas
    var tries = 0;
    var iv = setInterval(function () {
      if (start() || ++tries > 20) clearInterval(iv);
    }, 250);
  }
})();
